import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FaqAccordion = ({ faqs = [] }) => {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;
  return (
    <div className="sp-faq">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div className={`sp-faq-item ${isOpen ? 'open' : ''}`} key={i}>
            <button
              className="sp-faq-q"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? -1 : i)}
            >
              <span>{f.q}</span>
              {isOpen ? <Minus size={20} /> : <Plus size={20} />}
            </button>
            {isOpen && <div className="sp-faq-a"><p>{f.a}</p></div>}
          </div>
        );
      })}
    </div>
  );
};

export default FaqAccordion;
